<template>
  <div class="login">
    <div class="login__wrap">
      <div class="login__box login__box--join">
        <p class="login__title">평가자 계정생성</p>

        <!-- 동적 입력 리스트 -->
        <div class="form-list">
          <div
            class="form-item"
            v-for="(item, idx) in entries"
            :key="item.key"
          >
            <div class="input-box">
              <label>*아이디</label>
              <input type="text" v-model="item.id" placeholder="아이디를 입력하세요" />
            </div>
            <div class="input-box">
              <label>*비밀번호</label>
              <input type="password" v-model="item.password" placeholder="비밀번호를 입력하세요" />
            </div>

            <div class="input-box">
              <label>*이름</label>
              <input type="text" v-model="item.name" placeholder="이름을 입력하세요" />
            </div>

            <div class="row-actions">
              <button
                type="button"
                class="btn btn--outline"
                @click="removeEntry(idx)"
                v-if="entries.length > 1"
                aria-label="행 삭제"
              >
                제거
              </button>
            </div>
          </div>
        </div>

        <!-- 추가/저장 버튼 -->
        <div class="actions">
          <button type="button" class="btn btn--ghost" @click="addEntry" aria-label="행 추가">+ 추가</button>
          <button type="button" class="btn btn--primary btn--half" @click="goUpdate">저장</button>
        </div>
      </div>
    </div>
  </div>

  <!-- footer 그대로 -->
  <div class="footer">
    <p class="footer__address">
      08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬)
      <span>대표전화: 070-4489-7241</span>
    </p>
    <span class="footer__copy">Copyright by 2025 아트너컨설팅. All Right Reserved</span>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// import axios from 'axios'  // 실제 저장 API 사용 시 주석 해제
import { insertEvalUser } from '@/api/eval'

const store = useStore()
const router = useRouter()

// 동적 입력 행들
const entries = reactive([
  { key: cryptoRandomKey(), id: '', name: '', password: '' }
])

function addEntry() {
  entries.push({ key: cryptoRandomKey(), id: '', name: '', password: '' })
}

function removeEntry(index) {
  entries.splice(index, 1)
}

function cryptoRandomKey() {
  // 키 충돌 방지용 간단 키
  return Math.random().toString(36).slice(2) + Date.now().toString(36)
}

function validate() {
  // 필수값 간단 검증
  for (let i = 0; i < entries.length; i++) {
    const it = entries[i]
    if (!it.id?.trim()) return { ok: false, msg: `${i + 1}번째 행: 아이디를 입력하세요.` }
    if (!it.name?.trim()) return { ok: false, msg: `${i + 1}번째 행: 이름을 입력하세요.` }
    if (!it.password?.trim()) return { ok: false, msg: `${i + 1}번째 행: 비밀번호를 입력하세요.` }
  }
  return { ok: true }
}

async function goUpdate() {
  const v = validate()
  if (!v.ok) {
    alert(v.msg)
    return
  }

  // 전송 페이로드 예시
  const payload = entries.map(({ id, name, password }) => ({
    id : id,
    memberName :  name,
    memberPassword :  password
  }))

  try {
    console.log('저장 요청 페이로드:', payload)

    // 실제 저장 호출 예시
    //const res = await axios.post('/api/users/bulk', payload)
    // or
    const res = await insertEvalUser(payload)
    if (res.result == 'ok') {
      alert(res.resultMsg);
      router.push('/evalList')
    } else {
      alert(res.resultMsg);
    }
    // router.push('/somewhere')
  } catch (e) {
    console.error(e)
    alert('저장 중 오류가 발생했습니다.')
  }
}

onMounted(async () => {
  // 초기화 필요 시 작성
})
</script>

<style scoped>
/* 레이아웃 */
.login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.login__wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: start;
  padding: 20px;
}

.login__box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,.1);
  padding: 24px;
  width: 100%;
  max-width: 640px;
}

.login__title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
}

/* 1열 폼 */
.form-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-item {
  display: grid;
  grid-template-columns: 1fr; /* 1열 */
  gap: 10px;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafafa;
}

.input-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-box label {
  font-size: .95rem;
  font-weight: 600;
}

.input-box input {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: .95rem;
}

.row-actions {
  display: flex;
  justify-content: flex-end;
}

.actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 16px;
}

/* footer */
.footer {
  background-color: #f4f4f4;
  padding: 20px 0;
  text-align: center;
  font-size: 14px;
  color: #333;
  width: 100%;
  box-sizing: border-box;
}
.footer__address { margin-bottom: 8px; }
.footer__copy { font-size: 12px; color: #666; }

/* 반응형 */
@media (max-width: 768px) {
  .login__box { padding: 20px; }
  .actions { flex-direction: column; align-items: stretch; }
}
</style>
